import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { cancelRegistrationPayment } from '../services/api';

const PaymentCancel = () => {
    const [message, setMessage] = useState('');
    const location = useLocation();

    useEffect(() => {
        const urlParams = new URLSearchParams(location.search);
        const registrationId = urlParams.get('registrationId');

        if (registrationId) {
            // Optionally notify the server about the cancellation
            cancelRegistrationPayment(registrationId)
                .then(result => {
                    setMessage(result.message || 'Payment was cancelled.');
                })
                .catch(error => {
                    console.error('Error notifying cancellation:', error);
                    setMessage('Payment was cancelled.');
                });
        } else {
            setMessage('Payment was cancelled.');
        }
    }, [location]);

    return (
        <div className="container py-5">
            <div className="row justify-content-center">
                <div className="col-md-8">
                    <div className="card">
                        <div className="card-body text-center">
                            <div className="mb-4">
                                <i className="bi bi-x-circle-fill text-warning" style={{ fontSize: '4rem' }}></i>
                            </div>
                            <h2 className="card-title text-warning">Payment Cancelled</h2>
                            <p className="card-text">{message}</p>
                            <p className="text-muted">
                                Don't worry, no charges have been made to your account. 
                                You can try again or choose a different payment method.
                            </p>
                            <div className="mt-4">
                                <a href="/dashboard" className="btn btn-primary me-3">
                                    Try Payment Again
                                </a>
                                <a href="/" className="btn btn-outline-secondary">
                                    Return Home
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PaymentCancel;
